import React from "react";
import { useLang } from "../../contexts/LanguageContext";
import Reveal from "../Reveal";

export default function Opportunity() {
  const { t } = useLang();
  const c = t.opportunity;
  return (
    <section id="oportunidad" data-testid="opportunity-section" className="py-24 sm:py-32 border-t border-border">
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
        <div className="grid grid-cols-12 gap-y-10 gap-x-6 mb-16">
          <Reveal className="col-span-12 lg:col-span-3 flex items-start gap-4">
            <span className="block h-px w-12 bg-terracotta mt-3" aria-hidden />
            <span className="eyebrow">{c.eyebrow}</span>
          </Reveal>
          <Reveal as="h2" className="col-span-12 lg:col-span-9 h-section text-olive">
            {c.title}
          </Reveal>
          <Reveal className="col-span-12 lg:col-span-8 lg:col-start-4">
            <p className="text-lg text-olive-soft leading-relaxed">{c.intro}</p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-border">
          {c.items.map((it, idx) => (
            <Reveal
              key={it.n}
              delay={idx * 70}
              className="bg-ivory p-8 sm:p-12 transition-colors duration-500 hover:bg-ivory-pure"
              data-testid={`opportunity-card-${idx}`}
            >
              <div className="flex items-baseline justify-between mb-6">
                <span className="big-num text-6xl text-terracotta">{it.n}</span>
                <span className="font-mono text-[10px] tracking-[0.35em] uppercase text-olive-soft">
                  {String(idx + 1).padStart(2, "0")} / 04
                </span>
              </div>
              <h3 className="font-display text-2xl sm:text-3xl text-olive mb-5 leading-tight">{it.title}</h3>
              <p className="text-olive-soft leading-relaxed">{it.body}</p>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-20 grid grid-cols-12 gap-x-6 gap-y-6 items-baseline">
          <h3 className="col-span-12 lg:col-span-6 font-display italic text-4xl sm:text-5xl text-olive leading-tight">
            {c.closingTitle}
          </h3>
          <p className="col-span-12 lg:col-span-6 text-lg text-olive-soft leading-relaxed">
            {c.closingBody}
          </p>
        </Reveal>

        {c.phaseNotice && (
          <Reveal>
            <div data-testid="opportunity-phase-notice" className="mt-16 border-l-2 border-terracotta pl-6 sm:pl-8 max-w-4xl">
              <div className="font-mono text-[10px] tracking-[0.35em] uppercase text-terracotta mb-3">
                Estado del proyecto · Fase actual
              </div>
              <p className="font-serif italic text-2xl sm:text-3xl text-olive leading-snug">
                {c.phaseNotice}
              </p>
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
}
